module.exports = __webpack_public_path__ + "img/招商银行@2x.62d1a391.png";